<template>
	<div class="ProductCenter">
		<img class="pc" :src="bg" style="width: 100%;height: auto;" alt="" />
		<img class="mobile" :src="mobileBg" style="width: 100%;height: auto;" alt="" />
		<div class="profile_child ls-flex-col-center">
			<div class="profile_main w-100">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import { getIndexAd } from "@/api/api.js";
import routes from "../../router/routes";
export default {
	data() {
		return {
			bg:'',
			list: routes[2].children,
			path: routes[2].children[0].path,
			mobileBg:''
		};
	},
	created() {
		this.getData();
	},
	methods: {
		getData() {
			let _self = this;
			getIndexAd({
				zs_type:2,
				type:'pc'
			}).then((res) => {
				if (res.code == 1) {
					_self.bg = res.data[0].image;
				}else{
					_self.bg = require('@/assets/image/ProductCenter_bg.png')
				}
			});
			getIndexAd({
				zs_type:2,
				type:'mobile'
			}).then((res) => {
				if (res.code == 1) {
					_self.mobileBg = res.data[0].image;
				}else{
					_self.bg = require('@/assets/image/ProductCenter_bg.png');
				}
			});
		},
	},
	components: {
		
	},
};
</script>

<style lang="scss">
	.profile_child{
		@media screen and (max-width: 768px) {
			// padding: 0 15px;
		}
	}
	.pc{
		display: block;
		@media screen and (max-width: 768px) {
			display: none !important;
		}
	}
	.mobile{
		display: none;
		@media screen and (max-width: 768px) {
			display: block !important;
		}
	}
</style>